import { React, useEffect } from 'react'
import { AiFillHeart, AiOutlineShoppingCart } from 'react-icons/ai'
import { HiStar } from "react-icons/hi2";
import { Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { FaEye } from 'react-icons/fa'
import Ratings from '../Ratings'
import { add_to_card, messageClear, add_to_wishlist } from '../../store/reducers/cardReducer'
const ShopProducts = ({ styles, products }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { userInfo } = useSelector((state) => state.auth);
    const { successMessage, errorMessage } = useSelector((state) => state.card);
    

    useEffect(() => {
        if (successMessage) {
            toast.success(successMessage);
            dispatch(messageClear());
        }
        if (errorMessage) {
            toast.error(errorMessage);
            dispatch(messageClear());
        }
    }, [errorMessage, dispatch, successMessage]);
    const add_card = (id) => {
        if (userInfo) {
            dispatch(add_to_card({
                userId: userInfo.id,
                quantity: 1,
                productId: id
            }))
        } else {
            navigate('/login')
        }
    }

    const add_wishlist = (pro) => {
        if (userInfo) {
            dispatch(
                add_to_wishlist({
                    userId: userInfo.id,
                    productId: pro._id,
                    name: pro.name,
                    price: pro.price,
                    image: pro.images[0],
                    discount: pro.discount,
                    rating: pro.rating,
                    slug: pro.slug,
                })
            );
        }
        else {
            navigate('/login');
        }
    };
    return (
        <div className={`w-full grid ${styles === 'grid' ? 'grid-cols-3 md-lg:grid-cols-2 md:grid-cols-2' : 'grid-cols-1 md-lg:grid-cols-2 md:grid-cols-2'} gap-5`}>
            {
                products.map((p, i) => <div key={i} className={`flex transition-all duration-1000 hover:shadow-md hover:-translate-y-3 ${styles === 'grid' ? 'flex-col justify-start items-start' : 'justify-start items-center md-lg:flex-col md-lg:justify-start md-lg:items-start'} w-full gap-4 bg-white p-1 rounded-lg`}>
                    <div className={styles === 'grid' ? 'w-full relative group h-[210px] md:h-[270px] xs:h-[170px] overflow-hidden' : 'md-lg:w-full relative group h-[210px] md:h-[270px] overflow-hidden'}>
                        <img className='p-2 md-lg:p-0 h-[240px] rounded-[10px] md:h-[270px] xs:h-[170px] w-full object-cover' src={p.images[0]} alt="Productimage" />
                        <ul className='flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3'>
                            <button onClick={() => add_wishlist(p)} className='w-[38px] h-[38px] cursor-pointer bg-white flex justify-center items-center rounded-full hover:bg-secondary hover:text-white hover:rotate-[720deg] transition-all'><AiFillHeart /></button>
                            <Link className='w-[38px] h-[38px] cursor-pointer bg-white flex justify-center items-center rounded-full hover:bg-secondary hover:text-white hover:rotate-[720deg] transition-all' to={`/product/details/${p.slug}`}><FaEye /></Link>
                            <button onClick={() => add_card(p._id)} className='w-[38px] h-[38px] cursor-pointer bg-white flex justify-center items-center rounded-full hover:bg-secondary hover:text-white hover:rotate-[720deg] transition-all'><AiOutlineShoppingCart /></button>
                        </ul>
                    </div>
                    <Link to={`/product/details/${p.slug}`} className='flex  justify-start items-start p-2 flex-col gap-1'>
                        <h2 className='text-md text-slate-700 font-medium'>{p.name}</h2>
                        <div className='flex justify-start items-center gap-2'>
                            <span className='text-md  font-bold text-slate-700'>Rs.{p.price}</span>
                            <div className='flex text-lg'>
                                <div className='flex md:hidden'><Ratings className="md:hidden" ratings={p.rating} /></div>
                                <span className='text-sm flex items-center hidden md:flex'><HiStar className='mr-1 text-[#EDBB0E]' /> {p.rating}/5 </span>
                            </div>
                        </div>
                    </Link>
                </div>)
            }
        </div>
    )
}

export default ShopProducts